export default "__VITE_ASSET__CzjCwldB__"